import React from 'react'
import './experiences.css'
import { MdLocationOn } from 'react-icons/md'
import { experiences } from '../../data/profile';

const Experiences = () => {
  return (
    <section id="experiences">
      <h5>Employment History</h5>
      <h2>Job Experience</h2>

      <ol className="container timeline">
        {experiences.map(({ company, role, location, period, current, bullets, tech }) => (
          <li className={`timeline__item${current ? ' timeline__item--current' : ''}`} key={`${company}-${period}`}>
            <span className="timeline__dot" aria-hidden="true" />

            <article className="timeline__card">
              <div className="timeline__head">
                <div>
                  <h3 className="timeline__role">{role}</h3>
                  <p className="timeline__company">
                    {company}
                    <span className="timeline__location">
                      <MdLocationOn aria-hidden="true" /> {location}
                    </span>
                  </p>
                </div>
                <span className="timeline__period">
                  {current && <span className="timeline__badge">Current</span>}
                  {period}
                </span>
              </div>

              <ul className="timeline__bullets">
                {bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>

              {tech?.length > 0 && (
                <ul className="tag-list timeline__tags">
                  {tech.map((t) => (
                    <li className="tag" key={t}>{t}</li>
                  ))}
                </ul>
              )}
            </article>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Experiences
